import { type ObjectValuesUnionType } from '../../utils/typing';

export const RouterActionTypes = Object.freeze({
  ROUTE_HAS_CHANGED: 'ROUTER:ROUTE_HAS_CHANGED',
});
export type RouterActionType = ObjectValuesUnionType<typeof RouterActionTypes>;
